<template>
    <div class="routing-rules">
        <div class="routing-rules__header">
            <h1>Global Merchant Routing Rules</h1>
            <Button :buttonName="!contents.rules.length ? 'Add' : 'Edit'" :onClick="handleRedirect" classes="grey"  />
        </div>
        <div>
           <Table :contents="contents.rules" :hidePagination="true"  :hideTableTop="true" :loading="contents.loading" darkenAll>     
               <template v-slot:nocontent>	
                    <h1>No Routing Rules</h1>
                    <p>All routing rules will show here</p>
                </template>
           </Table>
        </div>
    </div>
</template>
<script>
import { reactive, onBeforeMount, computed, watch } from '@vue/composition-api'
import Table from "@/components/table.vue"
import Button from "@/components/button.vue"
import RoutineRule from "@/components/routingrule.vue"
import { deleteFromArrayOfObject, addToArray, modifyArrayById } from "@/lib/arrayManipulation"

export default {
    components: {
        Button,
        RoutineRule,
        Table
    },
    setup(props, { root }) {
        const store = root.$store;
        const contents = computed(() => store.getters.getGlobalRoutingRules);

        onBeforeMount(() => {
            store.dispatch('getRoutingRules')
        })

        const handleRedirect = () => {
            root.$router.push({  name: 'modify-routine-rules' })
        }

    
        return {
            contents,
            handleRedirect
        }
    }
}
</script>
<style lang="scss">
.routing-rules {
    width: 100%;

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
       padding: 0 130px 58px 130px;

        h1 {
            font-style: normal;
            font-weight: normal;
            font-size: 18px;
            line-height: 14px;
        }
    }

    .btn {
        width: 125px;
    }

    .table-component {
        border: none;
        margin: 0;
        margin-bottom: 50px;
        box-shadow: none;

        .no-content {
            padding: 90px 26px;
        }
    }
}
</style>